import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

let itemChecked2 = [];
export default class AdmSliderProductoExportacion extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mspe_Titulo:"",
                mspe_Partidas:"",
                mspe_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mspe_Id:0,
                mspe_Titulo:"",
                mspe_Partidas:"",
                mspe_Activo:true
            },
            Validacion: {
                mspe_Titulo: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mspe_Titulo: {
                    Error: false,                    
                }
            },
            resourcePartidas:{
                filtroPartidas:"",
                partidas:[],
                partidasIds:[]
            },
            itemChecked2:[],
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    onCheck = (item, id, e) => 
    {
        const target = e.target;
        itemChecked2[e.target.name] = !e.target.checked?false:true;

        let resourcePartidas = this.state.resourcePartidas;
        let partidasSeleccionadosObj = resourcePartidas.partidasIds;
        if(target.type === 'checkbox' )
        {
            if(e.target.checked){
                let obj = {
                    id: id,
                    nombre: item
                }
                partidasSeleccionadosObj[id] = obj;
            }else{
                partidasSeleccionadosObj[id] = null;
            }
        }
        resourcePartidas.partidasIds = partidasSeleccionadosObj;
        
        setTimeout(() => {
            this.setState({itemChecked2, resourcePartidas:resourcePartidas});
        },100)
    }

    searchPartidas = () => {

        let resourcePartidas = this.state.resourcePartidas;
        let textoFilter = resourcePartidas.filtroPartidas;

        if(textoFilter === '')
        {   
            resourcePartidas.partidas = [];    
            this.setState({resourcePartidas:resourcePartidas});
            return;
        }

        const url = `${API_URL}GeneralUX/ObtenerLProductoPartida/${textoFilter}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            resourcePartidas.partidas = data.result;
            this.setState({resourcePartidas:resourcePartidas});
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }

    PartidasSeleccionados()
    {
        let partidasNombre = [];

        this.state.resourcePartidas.partidasIds.forEach(partida => {
            if(partida != null){
                partidasNombre.push(partida.nombre);
            }  
        });

        return partidasNombre.length > 0 ? partidasNombre.join('|') : '';
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.searchPartidas();
        }
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(target.name == 'filtroPartidas'){
            let copyResource = this.state.resourcePartidas;
            copyResource[target.name] = value;

            this.setState({
                resourcePartidas: copyResource
            });

        }else{
            let copyResource = this.state.resource;
            copyResource[target.name] = value;
    
            let validaciones = this.state.Validacion;
    
            validaciones[target.name] = {
                Error: false,                    
            }
    
            this.setState({
                resource: copyResource,
                Validacion: validaciones
            });  
        }

        
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mspe_Titulo == '') {              
            newState.Validacion.mspe_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let partidas_id = [];

        this.state.resourcePartidas.partidasIds.forEach(partida => {
            if(partida != null){
                partidas_id.push(partida.id);
            }  
        });

        const url = `${API_URL}ModuloSliderProductoExportacionUX/`;
        var dataForm = this.state.resource;
        dataForm.mspe_Partidas = partidas_id.join(",");
        dataForm = updateValueInJson(dataForm,'mspe_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mspe_Titulo = '';

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mspe_Titulo == '') {              
            newState.ValidacionEdit.mspe_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let partidas_id = [];

        this.state.resourcePartidas.partidasIds.forEach(partida => {
            if(partida != null){
                partidas_id.push(partida.id);
            }  
        });

        const url = `${API_URL}ModuloSliderProductoExportacionUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm.mspe_Partidas = partidas_id.join(",");
        dataForm = updateValueInJson(dataForm,'mspe_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mspe_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloSliderProductoExportacionUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let partidasIdString = data.result.partidasIdNombre;
            let partidasIds = [];
            if(partidasIdString != ''){

                let partidasIdArray = partidasIdString.split('/');

                if(partidasIdArray.length > 0)
                {
                    partidasIdArray.forEach(idnombre => {

                        idnombre = idnombre.trim();

                        if(idnombre != ''){
                            let arrayString = idnombre.split('|');
                            
                            itemChecked2["check_" + arrayString[0]] = true;
                            partidasIds[arrayString[0]] = {
                                id: arrayString[0],
                                nombre: arrayString[1]
                            }
                        }
                    });
                }
            }

            let resourcePartidas = {
                filtroPartidas:"",
                partidas:[],
                partidasIds:partidasIds
            }
            
            this.setState({ resourceEdit: data.result, resourcePartidas:resourcePartidas, itemChecked2:itemChecked2, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 51;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mspe_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                
                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Título" 
                                    value={this.state.resourceEdit.mspe_Titulo} 
                                    name="mspe_Titulo"  
                                    className={this.state.ValidacionEdit.mspe_Titulo.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={300} />
                                </div>

                                <div className="txtSelect-Radio">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Seleccionar partidas:</b></p>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Buscar..." 
                                        name="filtroPartidas" 
                                        value={this.state.resourcePartidas.filtroPartidas}
                                        classname="buscadorItemsPaises" 
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                                        {
                                            this.state.resourcePartidas.partidas.length > 0 ?
                                            this.state.resourcePartidas.partidas.map((partida) => (
                                                <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                                    <input type="checkbox" 
                                                    style={{WebkitAppearance: 'checkbox'}} 
                                                    name={"check_" + partida.partida_id} 
                                                    checked={this.state.itemChecked2["check_" + partida.partida_id]}  
                                                    onClick={(event) => this.onCheck(partida.nombre_producto, partida.partida_id, event)}/>
                                                    <label className="lblpartidaslider">{partida.nombre_producto}</label>
                                                </div> 
                                            )) : null
                                        }                           
                                    </div>
                                </div>

                                <div className="textareaResumen x-1">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Partidas seleccionadas:</b></p>
                                    <textarea placeholder="Partidas Seleccionadas" value={this.PartidasSeleccionados()} style={{height:"100px"}}/>
                                </div>

                                <div className="divModulo_Seo">
                                    <h2><strong>Configuración de modulo</strong></h2>
                                    <div className="divWrapperModulo_Seo">
                                        
                                        <div className="txtFile x-2">
                                            <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>	

                                        <div className="txtFile x-1">
                                            <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Perfil</option>
                                                {
                                                    this.state.perfiles.length > 0 ?
                                                    this.state.perfiles.map((perfil) => (
                                                        <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>

                                        <div className="txtFile x-1 ocultarcms">
                                            <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Sector</option>
                                                {
                                                    this.state.sectores.length > 0 ?
                                                    this.state.sectores.map((sector) => (
                                                        <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>
                                        
                                    </div>
                                </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    
                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Título" 
                                        value={this.state.resource.mspe_Titulo} 
                                        name="mspe_Titulo"  
                                        className={this.state.Validacion.mspe_Titulo.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={300} />
                                    </div>

                                    <div className="txtSelect-Radio">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Seleccionar partidas:</b></p>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Buscar..." 
                                        name="filtroPartidas" 
                                        value={this.state.resourcePartidas.filtroPartidas}
                                        classname="buscadorItemsPaises" 
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                                        {
                                            this.state.resourcePartidas.partidas.length > 0 ?
                                            this.state.resourcePartidas.partidas.map((partida) => (
                                                <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                                    <input type="checkbox" 
                                                    style={{WebkitAppearance: 'checkbox'}} 
                                                    name={"check_" + partida.partida_id} 
                                                    checked={this.state.itemChecked2["check_" + partida.partida_id]}  
                                                    onClick={(event) => this.onCheck(partida.nombre_producto, partida.partida_id, event)}/>
                                                    <label className="lblpartidaslider">{partida.nombre_producto}</label>
                                                </div> 
                                            )) : null
                                        }                           
                                    </div>
                                </div>

                                <div className="textareaResumen x-1">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Partidas seleccionadas:</b></p>
                                    <textarea placeholder="Partidas Seleccionadas" value={this.PartidasSeleccionados()} style={{height:"100px"}}/>
                                </div>


                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1 ocultarcms">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} key={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}